import PLATFORM from '../../constants/platformTypes';

export const getPlatform = (state) => state.init.platform;
export const getIsMobile = (state) => state.init.platform === PLATFORM.MOBILE;
export const getIsNative = (state) => state.init.isNative === true;
export const getIsIos = (state) => state.init.isIos;
export const getPackageId = (_) => window.packageId;
